import React, { useState, useEffect, useContext, useRef } from 'react';
import './AverageResponse.css';
import convenienceApi from '../../common/api/convenience';
import Card from '../Card/Card';
import CardContent from '../Card/CardContent';
import CardLink from '../Card/CardLink';
import CardLinkReport from '../Card/CardLinkReport';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { CardAverageResponseContext } from '../../contexts/CardAverageResponseContext';
import AverageAlarmResponseContent from './AverageResponseContent';
import AverageAlarmResponseLoadingStatus from './AverageResponseLoadingStatus';
import AverageAlarmResponseTimeRange from './AverageResponseTimeRange';
import logComponent from '../../common/logComponent';

export default function AverageAlarmResponse({ moduleDescription }) {
  const environmentContext = useContext(EnvironmentContext);
  //Note:  We are using context for data and time range because it wasn't updating the CardContent children when data changed or current time stamp changed
  const cardAverageResponseContext = useContext(CardAverageResponseContext);
  const { timeRanges } = cardAverageResponseContext;
  const [currentTimeRange, setCurrentTimeRange] = useState(timeRanges[0]);
  const { hasToken, activeUser: user, reportsEnabled } = environmentContext;
  const loadingRef = useRef(false);


 const setLoadingRef = (el) => {
   if (logComponent('AverageAlarmResponse')) { console.debug('AverageAlarmResponse setLoadingRef'); }
    loadingRef.current = el;
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('AverageAlarmResponse')) {console.debug('AverageAlarmResponse onMount'); }
    if (!hasToken) return;

    loadData();
  }, []);

  useEffect(() => {
    if (logComponent('AverageAlarmResponse')) {console.debug('AverageAlarmResponse useEffect [hasToken, currentTimeRange ]'); }
    if (!hasToken) return;

    loadData();

  }, [hasToken, currentTimeRange]);

  useEffect(() => {
    if (logComponent('AverageAlarmResponse')) {console.debug('AverageAlarmResponse useEffect [environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit]'); }
    if (!hasToken) return;

    if (currentTimeRange !== timeRanges[0]) {
      updateTimeRange(timeRanges[0]);
    } else {
      loadData();
    }

  }, [environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit]);

  const loadData = () => {
    if (logComponent('AverageAlarmResponse')) {console.debug('AverageAlarmResponse loadData'); }

    const { hasToken } = environmentContext;
    const { setAverageResponse, setAverageResponseLoading, setAverageResponseError } = cardAverageResponseContext;
    if (!hasToken || loadingRef.current) return;
    setLoadingRef(true);

    let days = null;

    switch (currentTimeRange) {
      case 'Past 7 days':
        days = 7;
        break;
      case 'Past 30 days':
        days = 30;
        break;
      default:
        break;
    }

    if (!days) return;

    const { selectedMonitoredIndividual, selectedUnit, activeUser: user } = environmentContext;
    setAverageResponse(null);
    setAverageResponseLoading(true);
    setAverageResponseError(false);

    convenienceApi.getAverageResponseData(days, user, selectedMonitoredIndividual, selectedUnit)
      .then(
        result => {
          setAverageResponse(result);
          setAverageResponseLoading(false);
          setAverageResponseError(false);
          setLoadingRef(false);
       },
        error => {
          setAverageResponse(null);
          setAverageResponseLoading(false);
          setAverageResponseError(true);
          setLoadingRef(false);
        }
      )
  }

  const updateTimeRange = (newRange) => {
    if (logComponent('AverageAlarmResponse')) {console.debug('AverageAlarmResponse updateTimeRange'); }
    const { setAverageResponseTimeRange } = cardAverageResponseContext;
    setAverageResponseTimeRange(newRange);
    setCurrentTimeRange(newRange);
  }

  if (logComponent('AverageAlarmResponse')) { console.debug('AverageAlarmResponse rendered'); }


  return (
    <Card className="Average-Response" title="Avg alarm response" moduleDescription={moduleDescription} icon="stopwatch">
      <CardContent>
        <AverageAlarmResponseTimeRange updateTimeRange={ updateTimeRange } />
        <AverageAlarmResponseContent />
        <AverageAlarmResponseLoadingStatus reloadAction={loadData} />
      </CardContent>
      { 
        user.groupTypeString !== 'Family' && reportsEnabled &&
        <CardLink>
            <CardLinkReport reportId={5} />
        </CardLink>          
      }
    </Card>
  );
}